import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        // Revisar si hay actualización cada vez que se abre
        reg.update();
        // Cuando se detecta un service worker nuevo esperando, activarlo
        reg.addEventListener('updatefound', () => {
          const nuevoSW = reg.installing;
          if (nuevoSW) {
            nuevoSW.addEventListener('statechange', () => {
              if (nuevoSW.state === 'installed' && navigator.serviceWorker.controller) {
                // Hay una versión nueva lista: recargar para aplicarla
                window.location.reload();
              }
            });
          }
        });
      })
      .catch(err => console.log('SW error:', err));
    // Si el service worker cambia de control, recargar una vez
    let recargado = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!recargado) { recargado = true; window.location.reload(); }
    });
  });
}
